//export const SERVER_URL = "https://127.0.0.1:8000/api/";
//export const FILE_URL = "https://127.0.0.1:8000/storage/";
export const SHARED_DEBT_LINK = "https://api.maisura.co";
export const SERVER_URL = "https://api.maisura.co/api/";
export const FILE_URL = "https://api.maisura.co/maisuraapi/public/storage/";
//nice for this page to categorys add optioanl image for categorys https://192.168.8.102:8080/item-category  fro databse and frontexport const FILE_URL = "https://serdam-api.wise-manager.info/WiseManager/public/storage/";

//export a list of constants
export const CURRENCYS = [{
        cur_id: 1,
        id: 1,
        cur_name: "dinar",
        cur_symbol: "IQD",
        cur_is_main: 1,

    },
    {
        cur_id: 2,
        id: 1,
        cur_name: "dollar",
        cur_symbol: "$",
        cur_is_main: 0,
    },
];